import FtrDesc from './FtrDesc';
export default FtrDesc;